import {
  ListNoteRequest,
  NoteServiceClient,
  Note,
} from '../proto/accountpb/note_grpc_web_pb';
import { stringToProtoTimeSpan } from './ConvertService';

import { auth } from '../lib/auth/Auth';
const service = new NoteServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

export async function listNote(accountId, param) {
  return new Promise((resolve, reject) => {
    const req = new ListNoteRequest();
    req.setAccountId(accountId);
    req.setLinkId(param.linkId);
    req.setNoteType(param.noteType);

    service.listNote(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function createNote(param) {
  return new Promise((resolve, reject) => {
    const req = new Note();
    req.setAccountId(param.accountId);
    req.setLinkId(param.linkId);
    req.setNoteType(param.noteType);
    req.setSubject(param.subject);
    req.setNote(param.note);
    req.setCreatedBy(param.createdBy);
    req.setCreatedAt(stringToProtoTimeSpan(param.createdAt));

    service.createNote(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
